import styled from "styled-components";
import { Box } from "@mui/material";

export const ProductImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 4px;
  object-fit: cover;
  margin-right: 8px;
`;

export const ProductName = styled.span`
  font-weight: 600;
  font-size: 14px;
  color: #000000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  display: inline-block;
`;

export const TopPickBadge = styled.span`
  background: linear-gradient(135deg, #e39435 0%, #f4a261 100%);
  color: white;
  font-size: 12px;
  font-weight: 700;
  padding: 8px 16px;
  border-radius: 16px;
  margin-left: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 4px rgba(227, 148, 53, 0.3);
  animation: pulse 2s infinite;

  @keyframes pulse {
    0% {
      box-shadow: 0 2px 4px rgba(227, 148, 53, 0.3);
    }
    50% {
      box-shadow: 0 2px 8px rgba(227, 148, 53, 0.5);
    }
    100% {
      box-shadow: 0 2px 4px rgba(227, 148, 53, 0.3);
    }
  }
`;

export const ProductPrice = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #000000;
`;

export const ViewDetailsLink = styled.span`
  color: #e39435;
  cursor: pointer;
  font-size: 14px;
  &:hover {
    text-decoration: underline;
  }
`;

export const FlexContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const PageContainer = styled(Box)`
  padding: 24px;
  min-height: calc(100vh - 64px);

  @media (max-width: 767px) {
    padding: 8px;
  }
`;

export const TabContainer = styled(Box)`
  min-height: calc(100vh - 64px);

  @media (max-width: 767px) {
    padding: 8px;
  }
`;

export const ContentPaper = styled.div`
  margin-bottom: 32px;
`;

export const SectionTitle = styled.h2`
  font-size: 22px;
  font-weight: 500;
  color: #5a5a5a;

  @media (max-width: 767px) {
    margin-bottom: 16px;
  }
`;

export const InventoryHeader = styled(Box)`
  display: flex;
  flex-direction: row;

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

export const InventoryStatBox = styled.div`
  width: 150px;
  margin-right: 2rem;
  margin-bottom: 16px;
  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;

export const StatLabel = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #c2b6a6;
  margin-bottom: 12px;
`;

export const StatValue = styled.div<{ color?: string }>`
  font-size: 30px;
  font-weight: 500;
  color: ${(props) => props.color || "#5BA43B"};
`;

export const TopSellingContainer = styled(Box)`
  background: #f6f6f6;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-left: -40px;
  margin-right: -40px;

  @media (max-width: 767px) {
    padding: 32px;
  }
`;

export const ChartContainer = styled(Box)`
  min-width: 200px;
  min-height: 200px;
  margin: 0 auto;

  @media (max-width: 767px) {
    margin-bottom: 24px;
  }
`;

export const ActionBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  max-width: 100%;
  align-items: center;
  margin-bottom: 16px;
  gap: 16px;
  box-sizing: border-box;
  flex: 1;
  
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    
    & > * {
      width: 100%;
    }
  }
`;

export const DropdownWrapper = styled.div`
  width: 284px;
  height: 56px;
  border-color: #e39435 !important;
  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const DropdownWrapperFullWidth = styled.div`
  width: 100%;
  min-height: 56px;
  border-color: #e39435 !important;
  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const SearchContainer = styled(Box)`
  width: 284px;
  height: 56px;

  @media (max-width: 767px) {
    width: 100%;
    margin-bottom: 16px;
  }
`;

export const SearchWrapper = styled.div`
  position: relative;
  width: 284px;
  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const SearchInput = styled.input<{ height?: number }>`
  width: 100%;
  height: ${props => props.height ? props.height+'px' : '50px'};
  padding: 12px 16px 12px 48px;
  border: 1px solid #e39435;
  border-radius: 6px;
  font-size: 14px;
  color: #2d3748;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border: 2px solid #76b041;
  }

  &:hover {
    border-color: #76b041;
  }

  &::placeholder {
    color: #b8b8b8;
  }
`;

export const SearchIcon = styled.span`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #a0aec0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AddButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #e39435;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 700;
  height: 50px;
  width: 200px;
  cursor: pointer;

  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const PageHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: start;
  }
`;

export const PageTitle = styled.div`
  font-size: 30px;
  font-weight: 400;
  color: #5a5a5a;

  @media (max-width: 767px) {
    margin-bottom: 16px;
  }
`;

export const SellingItem = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #e2e8f0;

  &:last-child {
    border-bottom: none;
  }
`;

export const ItemRank = styled.div<{ color: string }>`
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background-color: ${(props) => props.color};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  margin-right: 12px;
`;

export const ItemInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  padding: 8px 0;
`;

export const ItemName = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #2d3748;
  margin-right: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ItemPrice = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #2d3748;
  margin-right: 16px;
`;

export const ItemSold = styled.span`
  font-size: 12px;
  color: #e39435;
  white-space: nowrap;
`;
